<app-header [title]="title" [subtitle]="subtitle"></app-header>
<main class="how-choose-color">
    <div class="container">
        <img src="assets/photos/dom1.jpg">
        <div class="tip-container" *ngFor="let tip of tips"
         [ngClass]="{'selected': selectedTip == tip}" [attr.id]="tip.id">
            <div class="leaning info btn-border-rev" (mouseover)="mouseSelectTip(tip)" (mouseout)="mouseSelectTip(null)">i</div>
            <div class="leaning tip btn-border-rev">
                <div class="content">
                    <h3>{{tip.title}}</h3>
                    <p>{{tip.description}}</p>
                </div>
            </div>
        </div>


    </div>

  <div class="tips">
  <div class="tip-container2" *ngFor="let tip of tips"
       [ngClass]="{'selected': selectedTip == tip}" [attr.id]="tip.id">

    <div class=" tip btn-border-rev">
      <div class="content">
        <h3>{{tip.title}}</h3>
        <p>{{tip.description}}</p>
      </div>
    </div>
  </div>
  </div>
</main>

<app-footer [next]="next"></app-footer>
